import React from 'react'
import { StudentIframePage } from '../Common/StudentIframePage'

const StudentMainEssay = () => {
	return <StudentIframePage activeMenu="MainEssay" pageName="MainEssay" linkField="mainessaylink" title="Main Essay" />
}

export { StudentMainEssay }
